import { CustomerCostConfigurationCycleJson } from './json';

export function getCycleDescription(item: CustomerCostConfigurationCycleJson, fallbackToId?: boolean): string
{
  if (item.costConfigurationCycleTypes && item.customerLanguageGroups)
  {
    const customerLanguageGroupsDesc = item.customerLanguageGroups.map(group => group.name).sort().join(', ');
    const cycleDesc = item.costConfigurationCycleTypes.map(type => `${type.costType}: ${item.firstCycleDuration}/${item.followingCycleDuration} (${type.costUnit})`).sort().join(', ');
    return `${customerLanguageGroupsDesc} - ${cycleDesc}`;
  }

  return fallbackToId ? `(ID: ${item.id})` : '';
}
